<div class="w-full flex flex-col gap-[0.5rem] px-[0.75rem] sm:px-[1rem] pb-3 sm:pb-(--date-selection-reserved-height-for-sm-and-md) lg:pb-0">
  <ng-container *ngxPermissionsOnly="[PermissionName.LeakDetection_Write_Comments]; else readOnlyComment">
    @if (!!this.comment()) {
      <div class="flex flex-col gap-[0.5rem] pb-[0.625rem] self-start">
        <div class="text-[0.75rem] font-[600] text-(--p-primary-300) leading-[150%]"
             translate="@@shared-last-modified-by">
        </div>

        <gc-comment-author [name]="commentAuthor()" [date]="commentModifiedAt()" />
      </div>
    }

    <gc-comment-form class="max-w-[30rem]" [showSuccessMessage]="commentSaved()" [facade]="commentFacade"></gc-comment-form>
  </ng-container>

  <ng-template #readOnlyComment>
    @if (comment()) {
      <gc-comment-card
        class="max-w-[30rem] pb-[0.625rem]"
        [showCommentLabel]="true"
        [authorName]="commentAuthor()"
        [authorDate]="commentModifiedAt()"
        [message]="message()">
      </gc-comment-card>
    } @else {
      <div class="pt-[0.625rem] text-[0.875rem] font-[600] text-(--p-blue-500) leading-[150%]" translate="@@edit-comment-no-comments-yet"></div>
    }
  </ng-template>
</div>
